// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AcademyRouteImport } from './routes/academy'
import { Route as AppRouteImport } from './routes/app'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BestPropFirmsForGoldRouteImport } from './routes/best-prop-firms-for-gold'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as EducationRouteImport } from './routes/education'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as GoldAnalysisRouteImport } from './routes/gold-analysis'
import { Route as GoldCentralBankReservesRouteImport } from './routes/gold-central-bank-reserves'
import { Route as GoldCotReportRouteImport } from './routes/gold-cot-report'
import { Route as GoldDailyRangeAtrRouteImport } from './routes/gold-daily-range-atr'
import { Route as GoldDxyCorrelationRouteImport } from './routes/gold-dxy-correlation'
import { Route as GoldInflationCpiRouteImport } from './routes/gold-inflation-cpi'
import { Route as GoldKillzonesClockRouteImport } from './routes/gold-killzones-clock'
import { Route as GoldMarginCalculatorRouteImport } from './routes/gold-margin-calculator'
import { Route as GoldNfpEmploymentRouteImport } from './routes/gold-nfp-employment'
import { Route as GoldOptionsSentimentRouteImport } from './routes/gold-options-sentiment'
import { Route as GoldPipCalculatorRouteImport } from './routes/gold-pip-calculator'
import { Route as GoldRealYieldRouteImport } from './routes/gold-real-yield'
import { Route as GoldRetailSentimentRouteImport } from './routes/gold-retail-sentiment'
import { Route as GoldScalpingStrategyRouteImport } from './routes/gold-scalping-strategy'
import { Route as GoldSeasonalityRouteImport } from './routes/gold-seasonality'
import { Route as GoldTradingSessionsRouteImport } from './routes/gold-trading-sessions'
import { Route as GoldTradingStrategyRouteImport } from './routes/gold-trading-strategy'
import { Route as InvestorPreviewRouteImport } from './routes/investor-preview'
import { Route as MacrolensRouteImport } from './routes/macrolens'
import { Route as OrionRouteImport } from './routes/orion'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as PositionSizeCalculatorRouteImport } from './routes/position-size-calculator'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PropFirmGoldRouteImport } from './routes/prop-firm-gold'
import { Route as RefundPolicyRouteImport } from './routes/refund-policy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RiskDisclaimerRouteImport } from './routes/risk-disclaimer'
import { Route as SignalsRouteImport } from './routes/signals'
import { Route as SmartMoneyConceptsRouteImport } from './routes/smart-money-concepts'
import { Route as TerminalRouteImport } from './routes/terminal'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TrackRecordRouteImport } from './routes/track-record'
import { Route as TradeLogRouteImport } from './routes/trade-log'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as ValidationRouteImport } from './routes/validation'
import { Route as WhatIsXauusdRouteImport } from './routes/what-is-xauusd'
import { Route as XauusdAnalysisTodayRouteImport } from './routes/xauusd-analysis-today'
import { Route as XauusdTradingRouteImport } from './routes/xauusd-trading'
import { Route as XauusdVolatilityHeatmapRouteImport } from './routes/xauusd-volatility-heatmap'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AppNativeReturnRouteImport } from './routes/app_.native-return'
import { Route as CaseStudiesIndexRouteImport } from './routes/case-studies.index'
import { Route as CaseStudiesIdRouteImport } from './routes/case-studies.$id'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as EducationIndexRouteImport } from './routes/education.index'
import { Route as EducationSlugRouteImport } from './routes/education.$slug'
import { Route as OrionHowItWorksRouteImport } from './routes/orion_.how-it-works'
import { Route as PlatformIndexRouteImport } from './routes/platform.index'
import { Route as PlatformExecutionDeskRouteImport } from './routes/platform.execution-desk'
import { Route as PlatformStructurelensRouteImport } from './routes/platform.structurelens'
import { Route as WeeklyOutlookIndexRouteImport } from './routes/weekly-outlook.index'
import { Route as WeeklyOutlookSlugRouteImport } from './routes/weekly-outlook.$slug'
import { Route as XauusdTradingUkRouteImport } from './routes/xauusd-trading_.uk'
import { Route as XauusdTradingUsaRouteImport } from './routes/xauusd-trading_.usa'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminAcquisitionRouteImport } from './routes/_authenticated/admin.acquisition'
import { Route as AuthenticatedAdminBroadcastsRouteImport } from './routes/_authenticated/admin.broadcasts'
import { Route as AuthenticatedAdminHistoryRouteImport } from './routes/_authenticated/admin.history'
import { Route as AuthenticatedAdminOeasShadowRouteImport } from './routes/_authenticated/admin.oeas-shadow'
import { Route as AuthenticatedAdminOtasRouteImport } from './routes/_authenticated/admin.otas'
import { Route as AuthenticatedAdminOtasShadowRouteImport } from './routes/_authenticated/admin.otas-shadow'
import { Route as AuthenticatedAdminPushTestsRouteImport } from './routes/_authenticated/admin.push-tests'
import { Route as AuthenticatedAdminSignalsRouteImport } from './routes/_authenticated/admin.signals'
import { Route as AuthenticatedAdminSubscribersRouteImport } from './routes/_authenticated/admin.subscribers'
import { Route as AuthenticatedAdminSwingShadowRouteImport } from './routes/_authenticated/admin.swing-shadow'
import { Route as AuthenticatedAdminWaitlistRouteImport } from './routes/_authenticated/admin.waitlist'
import { Route as AuthenticatedAdminWeeklyOutlookRouteImport } from './routes/_authenticated/admin.weekly-outlook'
import { Route as AuthenticatedArchiveIndexRouteImport } from './routes/_authenticated/archive.index'
import { Route as AuthenticatedArchiveEntryIdRouteImport } from './routes/_authenticated/archive.$entryId'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard.index'
import { Route as AuthenticatedDashboardAnalystRouteImport } from './routes/_authenticated/dashboard.analyst'
import { Route as AuthenticatedDashboardCalendarRouteImport } from './routes/_authenticated/dashboard.calendar'
import { Route as AuthenticatedDashboardEbooksRouteImport } from './routes/_authenticated/dashboard.ebooks'
import { Route as AuthenticatedDashboardEliteRouteImport } from './routes/_authenticated/dashboard.elite'
import { Route as AuthenticatedDashboardJournalRouteImport } from './routes/_authenticated/dashboard.journal'
import { Route as AuthenticatedDashboardLiquidityRouteImport } from './routes/_authenticated/dashboard.liquidity'
import { Route as AuthenticatedDashboardMacrolensRouteImport } from './routes/_authenticated/dashboard.macrolens'
import { Route as AuthenticatedDashboardMarginRouteImport } from './routes/_authenticated/dashboard.margin'
import { Route as AuthenticatedDashboardProfileRouteImport } from './routes/_authenticated/dashboard.profile'
import { Route as AuthenticatedDashboardPropFirmRouteImport } from './routes/_authenticated/dashboard.prop-firm'
import { Route as AuthenticatedDashboardSupportRouteImport } from './routes/_authenticated/dashboard.support'
import { Route as AuthenticatedDashboardToolsRouteImport } from './routes/_authenticated/dashboard.tools'
import { Route as AuthenticatedDashboardTradingRoomRouteImport } from './routes/_authenticated/dashboard.trading-room'
import { Route as AuthenticatedAdminBroadcastsIndexRouteImport } from './routes/_authenticated/admin.broadcasts.index'
import { Route as AuthenticatedAdminBroadcastsNewRouteImport } from './routes/_authenticated/admin.broadcasts.new'
import { Route as AuthenticatedAdminBroadcastsResendMeRouteImport } from './routes/_authenticated/admin.broadcasts.resend-me'
import { Route as AuthenticatedAdminCaseStudiesIndexRouteImport } from './routes/_authenticated/admin.case-studies.index'
import { Route as AuthenticatedAdminCaseStudiesIdRouteImport } from './routes/_authenticated/admin.case-studies.$id'
import { Route as AuthenticatedAdminSignalsIndexRouteImport } from './routes/_authenticated/admin.signals.index'
import { Route as AuthenticatedAdminSignalsDraftsRouteImport } from './routes/_authenticated/admin.signals.drafts'
import { Route as AuthenticatedAdminSignalsNewRouteImport } from './routes/_authenticated/admin.signals.new'
import { Route as AuthenticatedAdminWipCommandCenterRouteImport } from './routes/_authenticated/admin.wip.command-center'
import { Route as AuthenticatedAdminWipTradingRoomRouteImport } from './routes/_authenticated/admin.wip.trading-room'
import { Route as AuthenticatedDashboardAcademyIndexRouteImport } from './routes/_authenticated/dashboard.academy.index'
import { Route as AuthenticatedDashboardAcademySlugRouteImport } from './routes/_authenticated/dashboard.academy.$slug'
import { Route as AuthenticatedDashboardCaseStudiesIndexRouteImport } from './routes/_authenticated/dashboard.case-studies.index'
import { Route as AuthenticatedDashboardCaseStudiesIdRouteImport } from './routes/_authenticated/dashboard.case-studies.$id'
import { Route as AuthenticatedAdminSignalsIdEditRouteImport } from './routes/_authenticated/admin.signals.$id.edit'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AcademyRoute = AcademyRouteImport.update({
            id: '/academy',path: '/academy',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BestPropFirmsForGoldRoute = BestPropFirmsForGoldRouteImport.update({
            id: '/best-prop-firms-for-gold',path: '/best-prop-firms-for-gold',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const EducationRoute = EducationRouteImport.update({
            id: '/education',path: '/education',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const GoldAnalysisRoute = GoldAnalysisRouteImport.update({
            id: '/gold-analysis',path: '/gold-analysis',getParentRoute: () => rootRouteImport
          })
const GoldCentralBankReservesRoute = GoldCentralBankReservesRouteImport.update({
            id: '/gold-central-bank-reserves',path: '/gold-central-bank-reserves',getParentRoute: () => rootRouteImport
          })
const GoldCotReportRoute = GoldCotReportRouteImport.update({
            id: '/gold-cot-report',path: '/gold-cot-report',getParentRoute: () => rootRouteImport
          })
const GoldDailyRangeAtrRoute = GoldDailyRangeAtrRouteImport.update({
            id: '/gold-daily-range-atr',path: '/gold-daily-range-atr',getParentRoute: () => rootRouteImport
          })
const GoldDxyCorrelationRoute = GoldDxyCorrelationRouteImport.update({
            id: '/gold-dxy-correlation',path: '/gold-dxy-correlation',getParentRoute: () => rootRouteImport
          })
const GoldInflationCpiRoute = GoldInflationCpiRouteImport.update({
            id: '/gold-inflation-cpi',path: '/gold-inflation-cpi',getParentRoute: () => rootRouteImport
          })
const GoldKillzonesClockRoute = GoldKillzonesClockRouteImport.update({
            id: '/gold-killzones-clock',path: '/gold-killzones-clock',getParentRoute: () => rootRouteImport
          })
const GoldMarginCalculatorRoute = GoldMarginCalculatorRouteImport.update({
            id: '/gold-margin-calculator',path: '/gold-margin-calculator',getParentRoute: () => rootRouteImport
          })
const GoldNfpEmploymentRoute = GoldNfpEmploymentRouteImport.update({
            id: '/gold-nfp-employment',path: '/gold-nfp-employment',getParentRoute: () => rootRouteImport
          })
const GoldOptionsSentimentRoute = GoldOptionsSentimentRouteImport.update({
            id: '/gold-options-sentiment',path: '/gold-options-sentiment',getParentRoute: () => rootRouteImport
          })
const GoldPipCalculatorRoute = GoldPipCalculatorRouteImport.update({
            id: '/gold-pip-calculator',path: '/gold-pip-calculator',getParentRoute: () => rootRouteImport
          })
const GoldRealYieldRoute = GoldRealYieldRouteImport.update({
            id: '/gold-real-yield',path: '/gold-real-yield',getParentRoute: () => rootRouteImport
          })
const GoldRetailSentimentRoute = GoldRetailSentimentRouteImport.update({
            id: '/gold-retail-sentiment',path: '/gold-retail-sentiment',getParentRoute: () => rootRouteImport
          })
const GoldScalpingStrategyRoute = GoldScalpingStrategyRouteImport.update({
            id: '/gold-scalping-strategy',path: '/gold-scalping-strategy',getParentRoute: () => rootRouteImport
          })
const GoldSeasonalityRoute = GoldSeasonalityRouteImport.update({
            id: '/gold-seasonality',path: '/gold-seasonality',getParentRoute: () => rootRouteImport
          })
const GoldTradingSessionsRoute = GoldTradingSessionsRouteImport.update({
            id: '/gold-trading-sessions',path: '/gold-trading-sessions',getParentRoute: () => rootRouteImport
          })
const GoldTradingStrategyRoute = GoldTradingStrategyRouteImport.update({
            id: '/gold-trading-strategy',path: '/gold-trading-strategy',getParentRoute: () => rootRouteImport
          })
const InvestorPreviewRoute = InvestorPreviewRouteImport.update({
            id: '/investor-preview',path: '/investor-preview',getParentRoute: () => rootRouteImport
          })
const MacrolensRoute = MacrolensRouteImport.update({
            id: '/macrolens',path: '/macrolens',getParentRoute: () => rootRouteImport
          })
const OrionRoute = OrionRouteImport.update({
            id: '/orion',path: '/orion',getParentRoute: () => rootRouteImport
          })
const PlatformRoute = PlatformRouteImport.update({
            id: '/platform',path: '/platform',getParentRoute: () => rootRouteImport
          })
const PositionSizeCalculatorRoute = PositionSizeCalculatorRouteImport.update({
            id: '/position-size-calculator',path: '/position-size-calculator',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PropFirmGoldRoute = PropFirmGoldRouteImport.update({
            id: '/prop-firm-gold',path: '/prop-firm-gold',getParentRoute: () => rootRouteImport
          })
const RefundPolicyRoute = RefundPolicyRouteImport.update({
            id: '/refund-policy',path: '/refund-policy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RiskDisclaimerRoute = RiskDisclaimerRouteImport.update({
            id: '/risk-disclaimer',path: '/risk-disclaimer',getParentRoute: () => rootRouteImport
          })
const SignalsRoute = SignalsRouteImport.update({
            id: '/signals',path: '/signals',getParentRoute: () => rootRouteImport
          })
const SmartMoneyConceptsRoute = SmartMoneyConceptsRouteImport.update({
            id: '/smart-money-concepts',path: '/smart-money-concepts',getParentRoute: () => rootRouteImport
          })
const TerminalRoute = TerminalRouteImport.update({
            id: '/terminal',path: '/terminal',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TrackRecordRoute = TrackRecordRouteImport.update({
            id: '/track-record',path: '/track-record',getParentRoute: () => rootRouteImport
          })
const TradeLogRoute = TradeLogRouteImport.update({
            id: '/trade-log',path: '/trade-log',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const ValidationRoute = ValidationRouteImport.update({
            id: '/validation',path: '/validation',getParentRoute: () => rootRouteImport
          })
const WhatIsXauusdRoute = WhatIsXauusdRouteImport.update({
            id: '/what-is-xauusd',path: '/what-is-xauusd',getParentRoute: () => rootRouteImport
          })
const XauusdAnalysisTodayRoute = XauusdAnalysisTodayRouteImport.update({
            id: '/xauusd-analysis-today',path: '/xauusd-analysis-today',getParentRoute: () => rootRouteImport
          })
const XauusdTradingRoute = XauusdTradingRouteImport.update({
            id: '/xauusd-trading',path: '/xauusd-trading',getParentRoute: () => rootRouteImport
          })
const XauusdVolatilityHeatmapRoute = XauusdVolatilityHeatmapRouteImport.update({
            id: '/xauusd-volatility-heatmap',path: '/xauusd-volatility-heatmap',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AppNativeReturnRoute = AppNativeReturnRouteImport.update({
            id: '/app_/native-return',path: '/app/native-return',getParentRoute: () => rootRouteImport
          })
const CaseStudiesIndexRoute = CaseStudiesIndexRouteImport.update({
            id: '/case-studies/',path: '/case-studies/',getParentRoute: () => rootRouteImport
          })
const CaseStudiesIdRoute = CaseStudiesIdRouteImport.update({
            id: '/case-studies/$id',path: '/case-studies/$id',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const EducationIndexRoute = EducationIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EducationRoute
          })
const EducationSlugRoute = EducationSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => EducationRoute
          })
const OrionHowItWorksRoute = OrionHowItWorksRouteImport.update({
            id: '/orion_/how-it-works',path: '/orion/how-it-works',getParentRoute: () => rootRouteImport
          })
const PlatformIndexRoute = PlatformIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PlatformRoute
          })
const PlatformExecutionDeskRoute = PlatformExecutionDeskRouteImport.update({
            id: '/execution-desk',path: '/execution-desk',getParentRoute: () => PlatformRoute
          })
const PlatformStructurelensRoute = PlatformStructurelensRouteImport.update({
            id: '/structurelens',path: '/structurelens',getParentRoute: () => PlatformRoute
          })
const WeeklyOutlookIndexRoute = WeeklyOutlookIndexRouteImport.update({
            id: '/weekly-outlook/',path: '/weekly-outlook/',getParentRoute: () => rootRouteImport
          })
const WeeklyOutlookSlugRoute = WeeklyOutlookSlugRouteImport.update({
            id: '/weekly-outlook/$slug',path: '/weekly-outlook/$slug',getParentRoute: () => rootRouteImport
          })
const XauusdTradingUkRoute = XauusdTradingUkRouteImport.update({
            id: '/xauusd-trading_/uk',path: '/xauusd-trading/uk',getParentRoute: () => rootRouteImport
          })
const XauusdTradingUsaRoute = XauusdTradingUsaRouteImport.update({
            id: '/xauusd-trading_/usa',path: '/xauusd-trading/usa',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAcquisitionRoute = AuthenticatedAdminAcquisitionRouteImport.update({
            id: '/acquisition',path: '/acquisition',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBroadcastsRoute = AuthenticatedAdminBroadcastsRouteImport.update({
            id: '/broadcasts',path: '/broadcasts',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminHistoryRoute = AuthenticatedAdminHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminOeasShadowRoute = AuthenticatedAdminOeasShadowRouteImport.update({
            id: '/oeas-shadow',path: '/oeas-shadow',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminOtasRoute = AuthenticatedAdminOtasRouteImport.update({
            id: '/otas',path: '/otas',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminOtasShadowRoute = AuthenticatedAdminOtasShadowRouteImport.update({
            id: '/otas-shadow',path: '/otas-shadow',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPushTestsRoute = AuthenticatedAdminPushTestsRouteImport.update({
            id: '/push-tests',path: '/push-tests',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSignalsRoute = AuthenticatedAdminSignalsRouteImport.update({
            id: '/signals',path: '/signals',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSubscribersRoute = AuthenticatedAdminSubscribersRouteImport.update({
            id: '/subscribers',path: '/subscribers',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSwingShadowRoute = AuthenticatedAdminSwingShadowRouteImport.update({
            id: '/swing-shadow',path: '/swing-shadow',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminWaitlistRoute = AuthenticatedAdminWaitlistRouteImport.update({
            id: '/waitlist',path: '/waitlist',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminWeeklyOutlookRoute = AuthenticatedAdminWeeklyOutlookRouteImport.update({
            id: '/weekly-outlook',path: '/weekly-outlook',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedArchiveIndexRoute = AuthenticatedArchiveIndexRouteImport.update({
            id: '/archive/',path: '/archive/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedArchiveEntryIdRoute = AuthenticatedArchiveEntryIdRouteImport.update({
            id: '/archive/$entryId',path: '/archive/$entryId',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardIndexRoute = AuthenticatedDashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardAnalystRoute = AuthenticatedDashboardAnalystRouteImport.update({
            id: '/analyst',path: '/analyst',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardCalendarRoute = AuthenticatedDashboardCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardEbooksRoute = AuthenticatedDashboardEbooksRouteImport.update({
            id: '/ebooks',path: '/ebooks',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardEliteRoute = AuthenticatedDashboardEliteRouteImport.update({
            id: '/elite',path: '/elite',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardJournalRoute = AuthenticatedDashboardJournalRouteImport.update({
            id: '/journal',path: '/journal',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardLiquidityRoute = AuthenticatedDashboardLiquidityRouteImport.update({
            id: '/liquidity',path: '/liquidity',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardMacrolensRoute = AuthenticatedDashboardMacrolensRouteImport.update({
            id: '/macrolens',path: '/macrolens',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardMarginRoute = AuthenticatedDashboardMarginRouteImport.update({
            id: '/margin',path: '/margin',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardProfileRoute = AuthenticatedDashboardProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardPropFirmRoute = AuthenticatedDashboardPropFirmRouteImport.update({
            id: '/prop-firm',path: '/prop-firm',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardSupportRoute = AuthenticatedDashboardSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardToolsRoute = AuthenticatedDashboardToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardTradingRoomRoute = AuthenticatedDashboardTradingRoomRouteImport.update({
            id: '/trading-room',path: '/trading-room',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedAdminBroadcastsIndexRoute = AuthenticatedAdminBroadcastsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminBroadcastsRoute
          })
const AuthenticatedAdminBroadcastsNewRoute = AuthenticatedAdminBroadcastsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedAdminBroadcastsRoute
          })
const AuthenticatedAdminBroadcastsResendMeRoute = AuthenticatedAdminBroadcastsResendMeRouteImport.update({
            id: '/resend-me',path: '/resend-me',getParentRoute: () => AuthenticatedAdminBroadcastsRoute
          })
const AuthenticatedAdminCaseStudiesIndexRoute = AuthenticatedAdminCaseStudiesIndexRouteImport.update({
            id: '/case-studies/',path: '/case-studies/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCaseStudiesIdRoute = AuthenticatedAdminCaseStudiesIdRouteImport.update({
            id: '/case-studies/$id',path: '/case-studies/$id',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSignalsIndexRoute = AuthenticatedAdminSignalsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminSignalsRoute
          })
const AuthenticatedAdminSignalsDraftsRoute = AuthenticatedAdminSignalsDraftsRouteImport.update({
            id: '/drafts',path: '/drafts',getParentRoute: () => AuthenticatedAdminSignalsRoute
          })
const AuthenticatedAdminSignalsNewRoute = AuthenticatedAdminSignalsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedAdminSignalsRoute
          })
const AuthenticatedAdminWipCommandCenterRoute = AuthenticatedAdminWipCommandCenterRouteImport.update({
            id: '/wip/command-center',path: '/wip/command-center',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminWipTradingRoomRoute = AuthenticatedAdminWipTradingRoomRouteImport.update({
            id: '/wip/trading-room',path: '/wip/trading-room',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedDashboardAcademyIndexRoute = AuthenticatedDashboardAcademyIndexRouteImport.update({
            id: '/academy/',path: '/academy/',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardAcademySlugRoute = AuthenticatedDashboardAcademySlugRouteImport.update({
            id: '/academy/$slug',path: '/academy/$slug',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardCaseStudiesIndexRoute = AuthenticatedDashboardCaseStudiesIndexRouteImport.update({
            id: '/case-studies/',path: '/case-studies/',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedDashboardCaseStudiesIdRoute = AuthenticatedDashboardCaseStudiesIdRouteImport.update({
            id: '/case-studies/$id',path: '/case-studies/$id',getParentRoute: () => AuthenticatedDashboardRoute
          })
const AuthenticatedAdminSignalsIdEditRoute = AuthenticatedAdminSignalsIdEditRouteImport.update({
            id: '/$id/edit',path: '/$id/edit',getParentRoute: () => AuthenticatedAdminSignalsRoute
          })





const AuthenticatedAdminBroadcastsRouteChildren = {
  AuthenticatedAdminBroadcastsNewRoute: AuthenticatedAdminBroadcastsNewRoute,AuthenticatedAdminBroadcastsResendMeRoute: AuthenticatedAdminBroadcastsResendMeRoute,AuthenticatedAdminBroadcastsIndexRoute: AuthenticatedAdminBroadcastsIndexRoute
}

const AuthenticatedAdminBroadcastsRouteWithChildren = AuthenticatedAdminBroadcastsRoute._addFileChildren(AuthenticatedAdminBroadcastsRouteChildren)




const AuthenticatedAdminSignalsRouteChildren = {
  AuthenticatedAdminSignalsDraftsRoute: AuthenticatedAdminSignalsDraftsRoute,AuthenticatedAdminSignalsNewRoute: AuthenticatedAdminSignalsNewRoute,AuthenticatedAdminSignalsIndexRoute: AuthenticatedAdminSignalsIndexRoute,AuthenticatedAdminSignalsIdEditRoute: AuthenticatedAdminSignalsIdEditRoute
}

const AuthenticatedAdminSignalsRouteWithChildren = AuthenticatedAdminSignalsRoute._addFileChildren(AuthenticatedAdminSignalsRouteChildren)



const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAcquisitionRoute: AuthenticatedAdminAcquisitionRoute,AuthenticatedAdminBroadcastsRoute: AuthenticatedAdminBroadcastsRouteWithChildren,AuthenticatedAdminHistoryRoute: AuthenticatedAdminHistoryRoute,AuthenticatedAdminOeasShadowRoute: AuthenticatedAdminOeasShadowRoute,AuthenticatedAdminOtasRoute: AuthenticatedAdminOtasRoute,AuthenticatedAdminOtasShadowRoute: AuthenticatedAdminOtasShadowRoute,AuthenticatedAdminPushTestsRoute: AuthenticatedAdminPushTestsRoute,AuthenticatedAdminSignalsRoute: AuthenticatedAdminSignalsRouteWithChildren,AuthenticatedAdminSubscribersRoute: AuthenticatedAdminSubscribersRoute,AuthenticatedAdminSwingShadowRoute: AuthenticatedAdminSwingShadowRoute,AuthenticatedAdminWaitlistRoute: AuthenticatedAdminWaitlistRoute,AuthenticatedAdminWeeklyOutlookRoute: AuthenticatedAdminWeeklyOutlookRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminCaseStudiesIdRoute: AuthenticatedAdminCaseStudiesIdRoute,AuthenticatedAdminWipCommandCenterRoute: AuthenticatedAdminWipCommandCenterRoute,AuthenticatedAdminWipTradingRoomRoute: AuthenticatedAdminWipTradingRoomRoute,AuthenticatedAdminCaseStudiesIndexRoute: AuthenticatedAdminCaseStudiesIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)




const AuthenticatedDashboardRouteChildren = {
  AuthenticatedDashboardAnalystRoute: AuthenticatedDashboardAnalystRoute,AuthenticatedDashboardCalendarRoute: AuthenticatedDashboardCalendarRoute,AuthenticatedDashboardEbooksRoute: AuthenticatedDashboardEbooksRoute,AuthenticatedDashboardEliteRoute: AuthenticatedDashboardEliteRoute,AuthenticatedDashboardJournalRoute: AuthenticatedDashboardJournalRoute,AuthenticatedDashboardLiquidityRoute: AuthenticatedDashboardLiquidityRoute,AuthenticatedDashboardMacrolensRoute: AuthenticatedDashboardMacrolensRoute,AuthenticatedDashboardMarginRoute: AuthenticatedDashboardMarginRoute,AuthenticatedDashboardProfileRoute: AuthenticatedDashboardProfileRoute,AuthenticatedDashboardPropFirmRoute: AuthenticatedDashboardPropFirmRoute,AuthenticatedDashboardSupportRoute: AuthenticatedDashboardSupportRoute,AuthenticatedDashboardToolsRoute: AuthenticatedDashboardToolsRoute,AuthenticatedDashboardTradingRoomRoute: AuthenticatedDashboardTradingRoomRoute,AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,AuthenticatedDashboardAcademySlugRoute: AuthenticatedDashboardAcademySlugRoute,AuthenticatedDashboardCaseStudiesIdRoute: AuthenticatedDashboardCaseStudiesIdRoute,AuthenticatedDashboardAcademyIndexRoute: AuthenticatedDashboardAcademyIndexRoute,AuthenticatedDashboardCaseStudiesIndexRoute: AuthenticatedDashboardCaseStudiesIndexRoute
}

const AuthenticatedDashboardRouteWithChildren = AuthenticatedDashboardRoute._addFileChildren(AuthenticatedDashboardRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedDashboardRoute: AuthenticatedDashboardRouteWithChildren,AuthenticatedArchiveEntryIdRoute: AuthenticatedArchiveEntryIdRoute,AuthenticatedArchiveIndexRoute: AuthenticatedArchiveIndexRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const EducationRouteChildren = {
  EducationSlugRoute: EducationSlugRoute,EducationIndexRoute: EducationIndexRoute
}

const EducationRouteWithChildren = EducationRoute._addFileChildren(EducationRouteChildren)




const PlatformRouteChildren = {
  PlatformExecutionDeskRoute: PlatformExecutionDeskRoute,PlatformStructurelensRoute: PlatformStructurelensRoute,PlatformIndexRoute: PlatformIndexRoute
}

const PlatformRouteWithChildren = PlatformRoute._addFileChildren(PlatformRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AboutRoute: AboutRoute,AcademyRoute: AcademyRoute,AppRoute: AppRoute,AuthRoute: AuthRoute,BestPropFirmsForGoldRoute: BestPropFirmsForGoldRoute,ContactRoute: ContactRoute,EducationRoute: EducationRouteWithChildren,FaqRoute: FaqRoute,GoldAnalysisRoute: GoldAnalysisRoute,GoldCentralBankReservesRoute: GoldCentralBankReservesRoute,GoldCotReportRoute: GoldCotReportRoute,GoldDailyRangeAtrRoute: GoldDailyRangeAtrRoute,GoldDxyCorrelationRoute: GoldDxyCorrelationRoute,GoldInflationCpiRoute: GoldInflationCpiRoute,GoldKillzonesClockRoute: GoldKillzonesClockRoute,GoldMarginCalculatorRoute: GoldMarginCalculatorRoute,GoldNfpEmploymentRoute: GoldNfpEmploymentRoute,GoldOptionsSentimentRoute: GoldOptionsSentimentRoute,GoldPipCalculatorRoute: GoldPipCalculatorRoute,GoldRealYieldRoute: GoldRealYieldRoute,GoldRetailSentimentRoute: GoldRetailSentimentRoute,GoldScalpingStrategyRoute: GoldScalpingStrategyRoute,GoldSeasonalityRoute: GoldSeasonalityRoute,GoldTradingSessionsRoute: GoldTradingSessionsRoute,GoldTradingStrategyRoute: GoldTradingStrategyRoute,InvestorPreviewRoute: InvestorPreviewRoute,MacrolensRoute: MacrolensRoute,OrionRoute: OrionRoute,PlatformRoute: PlatformRouteWithChildren,PositionSizeCalculatorRoute: PositionSizeCalculatorRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,PropFirmGoldRoute: PropFirmGoldRoute,RefundPolicyRoute: RefundPolicyRoute,ResetPasswordRoute: ResetPasswordRoute,RiskDisclaimerRoute: RiskDisclaimerRoute,SignalsRoute: SignalsRoute,SmartMoneyConceptsRoute: SmartMoneyConceptsRoute,TerminalRoute: TerminalRoute,TermsRoute: TermsRoute,TrackRecordRoute: TrackRecordRoute,TradeLogRoute: TradeLogRoute,UnsubscribeRoute: UnsubscribeRoute,ValidationRoute: ValidationRoute,WhatIsXauusdRoute: WhatIsXauusdRoute,XauusdAnalysisTodayRoute: XauusdAnalysisTodayRoute,XauusdTradingRoute: XauusdTradingRoute,XauusdVolatilityHeatmapRoute: XauusdVolatilityHeatmapRoute,AppNativeReturnRoute: AppNativeReturnRoute,CaseStudiesIdRoute: CaseStudiesIdRoute,CheckoutReturnRoute: CheckoutReturnRoute,OrionHowItWorksRoute: OrionHowItWorksRoute,WeeklyOutlookSlugRoute: WeeklyOutlookSlugRoute,XauusdTradingUkRoute: XauusdTradingUkRoute,XauusdTradingUsaRoute: XauusdTradingUsaRoute,CaseStudiesIndexRoute: CaseStudiesIndexRoute,WeeklyOutlookIndexRoute: WeeklyOutlookIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)